module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-09.a29573db.svg";